'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/collapse/style/css.js
// module id = /jnN
// module chunks = 0